module.exports = __webpack_public_path__ + "general_terms_and_conditions.pdf";